// Centralized theme styles for form components
// Theme color: #008080 (teal)

export const THEME_COLOR = '#008080';
export const THEME_COLOR_HOVER = '#006666';

// InputLabel focused style
export const inputLabelFocusedStyle = {
  '&.Mui-focused': {
    color: THEME_COLOR
  }
};

// Select focused style
export const selectFocusedStyle = {
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: THEME_COLOR
  }
};

// Checkbox checked style
export const checkboxCheckedStyle = {
  '&.Mui-checked': {
    color: THEME_COLOR
  },
  '&.MuiCheckbox-indeterminate': {
    color: THEME_COLOR
  }
};

// Checkbox style (alias for convenience)
export const checkboxStyle = checkboxCheckedStyle;

// DatePicker styles
export const datePickerTextFieldStyle = {
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: THEME_COLOR
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: THEME_COLOR
  }
};

export const datePickerDayStyle = {
  '&.Mui-selected': {
    backgroundColor: `${THEME_COLOR} !important`,
    '&:hover': {
      backgroundColor: `${THEME_COLOR_HOVER} !important`
    }
  }
};

// Button styles
export const primaryButtonStyle = (disabled = false) => ({
  backgroundColor: disabled ? undefined : THEME_COLOR,
  '&:hover': {
    backgroundColor: disabled ? undefined : THEME_COLOR_HOVER
  }
});

export const outlinedButtonStyle = (disabled = false) => ({
  color: disabled ? 'gray' : THEME_COLOR,
  borderColor: disabled ? undefined : THEME_COLOR,
  '&:hover': {
    borderColor: disabled ? undefined : THEME_COLOR_HOVER
  }
});

// Combined DatePicker slotProps
export const datePickerSlotProps = (textFieldProps = {}) => ({
  textField: {
    ...textFieldProps,
    sx: {
      ...textFieldProps.sx,
      ...datePickerTextFieldStyle
    }
  },
  day: {
    sx: datePickerDayStyle
  }
});

// DatePicker style (alias for convenience)
export const datePickerStyle = {
  sx: {
    ...datePickerTextFieldStyle,
    '& .MuiPickersDay-root.Mui-selected': {
      backgroundColor: `${THEME_COLOR} !important`,
      '&:hover': {
        backgroundColor: `${THEME_COLOR_HOVER} !important`
      }
    }
  }
};

// Tab styles
export const tabStyle = {
  '&.Mui-selected': {
    color: THEME_COLOR
  }
};

// TabList indicator style
export const tabListStyle = {
  '& .MuiTabs-indicator': {
    backgroundColor: THEME_COLOR
  }
};

// Pagination styles
export const paginationStyle = {
  '& .MuiPaginationItem-root': {
    color: THEME_COLOR,
    borderColor: THEME_COLOR,
  },
  '& .Mui-selected': {
    backgroundColor: `${THEME_COLOR} !important`,
    color: '#ffffff',
  },
  '& .MuiPaginationItem-root:hover': {
    backgroundColor: '#009999',
    color: '#ffffff',
  },
};

// Button theme styles
export const buttonStyles = {
  contained: {
    backgroundColor: THEME_COLOR,
    color: '#ffffff',
    '&:hover': {
      backgroundColor: THEME_COLOR_HOVER,
    },
    '&:disabled': {
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
    }
  },
  outlined: {
    color: THEME_COLOR,
    borderColor: THEME_COLOR,
    '&:hover': {
      borderColor: THEME_COLOR_HOVER,
      backgroundColor: 'rgba(0, 128, 128, 0.04)',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      borderColor: 'rgba(0, 0, 0, 0.12)',
    }
  }
};

// Chip styles
export const chipStyle = {
  backgroundColor: THEME_COLOR,
  color: '#ffffff',
  '&:hover': {
    backgroundColor: THEME_COLOR_HOVER,
  }
};

